import React, {useEffect} from "react";
import Cloud from "../../Cloud/Cloud";
import {useSelector} from "react-redux";
import {setAutoDir, setWasInMiniCloud} from "../../../../../_reducers/cloudSlice";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";

const EditClientCloud = ({tabKey}) => {
    const dispatch = useTaggedDispatch({tabKey});
    const editClient = useSelector((state) => state.CLIENTS_DATA.editClient[tabKey]);

    useEffect(() => {
        dispatch(setWasInMiniCloud(true));
        dispatch(setAutoDir(`/ERP/Πελάτες/${editClient._id}`));
    }, []);

    return (
        <React.Fragment>
            <Cloud miniCloud={true} />
        </React.Fragment>
    )
}

export default EditClientCloud;